(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsDialogController', TabDomainsDialogController);

    TabDomainsDialogController.$inject = ['$state', '$timeout', '$scope', 'entity', 'TabDomains', 'User', 'DataUtils', 'Licences'];

    function TabDomainsDialogController($state, $timeout, $scope, entity, TabDomains, User, DataUtils, Licences) {
        var vm = this;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tabDomains = entity;
                if (vm.tabDomains.licenseExpirationDate != null) {
                    vm.tabDomains.licenseExpirationDate = new Date(vm.tabDomains.licenseExpirationDate);
                }
            });
        }
        vm.users = User.list({size: 1000});
        vm.licences = Licences.query();
        vm.datepickerOptions = {
            minDate: new Date()
        };

        vm.openUpCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleUpDatetime) {
                vm.scheduleUpDatetime.isOpen = !vm.scheduleUpDatetime.isOpen;
            } else {
                vm.scheduleUpDatetime = {isOpen: true};
            }

        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDomainsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-domains');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDomains.id !== null) {
                TabDomains.update(vm.tabDomains, onSaveSuccess, onSaveError);
            } else {
                TabDomains.save(vm.tabDomains, onSaveSuccess, onSaveError);
            }
        };

        vm.setDomainCertificate = function ($file, tabDomains, col) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        tabDomains[col] = base64Data;

                    });
                });
            }
        };

        vm.clear = function () {
            $state.go('tab-domains');
        };
    }
})();
